class GoogleSearchConsoleAPI {
    constructor() {}

    loadClient() {
        return new Promise((resolve, reject) => {
            gapi.load('client', () => {
                this.loadWebmasters()
                    .then(() => {
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        });
    }

    loadWebmasters() {
        return new Promise(resolve => {
            gapi.client.load('searchconsole', 'v1', () => {
                resolve();
            });
        });
    }

    setToken(accessToken) {
        gapi.client.setToken({
            access_token: accessToken
        });
    }

    getGSCSites() {
        return new Promise((resolve, reject) => {
            gapi.client.webmasters.sites
                .list({})
                .then(response => {
                    resolve(response.result.siteEntry);
                })
                .catch(error => {
                    reject(error.result.error);
                });
        });
    }
}

export default new GoogleSearchConsoleAPI();
